export const QUESTION_REPLY_LOCAL_STORAGE_KEY =
	'question-reply-local-storage-key';
